var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegramStatic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.8974 5.74781L30.4647 31.3684C30.0545 33.1763 28.986 33.6263 27.4674 32.7751L19.1891 26.675L15.1952 30.5172C14.7529 30.9595 14.3838 31.3285 13.5313 31.3285L14.1267 22.8985L29.4681 9.03573C30.1355 8.44167 29.3228 8.11121 28.4318 8.70656L9.46545 20.6495L1.3003 18.0933C-0.47546 17.5391 -0.507606 16.3175 1.67063 15.465L33.6073 3.16068C35.086 2.60648 36.3796 3.48986 35.8974 5.7491V5.74781Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramStatic);
export default __webpack_public_path__ + "static/media/telegram-static.cae7c2b0273b1d43ca131abeb86148ed.svg";
export { ForwardRef as ReactComponent };